import { Typography } from "@material-tailwind/react";
import { FC, PropsWithChildren } from "react";
import { ReactElement } from "react";

export type PageLayoutProps = {
  title: string;
  ActionButton?: ReactElement;
};

const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({
  title,
  children,
  ActionButton,
}) => {
  return (
    <div className="h-full w-full px-3 py-4 sm:px-4 sm:py-5 lg:px-6">
      <div className="mb-5 flex flex-col gap-3 border-b border-blue-gray-100 pb-4 sm:flex-row sm:items-center sm:justify-between">
        <Typography
          className="inline-block border-b-2 border-green-500 pb-1 text-2xl font-bold text-blue-gray-900 sm:text-3xl"
          variant="h3"
        >
          {title}
        </Typography>
        {ActionButton && (
          <div className="w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto">
            {ActionButton}
          </div>
        )}
      </div>

      {children}
    </div>
  );
};

export default PageLayout;
